import { Chakra } from "@airhelp/react-ui-components";

const { Box, Flex } = Chakra;

interface DotsProps {
  currentSlide: number;
  numberOfSlides: number;
  goToSlide: (slide: number) => void;
}

export const Dots = ({ currentSlide, numberOfSlides, goToSlide }: DotsProps) => {
  const dots = Array.from(Array(numberOfSlides).keys()).map((i) => {
    const color = i === currentSlide ? "primary.900" : "greyscale.400";
    const mr = i === numberOfSlides - 1 ? 0 : 4;

    return (
      <Box bg={color} cursor="pointer" w={2} h={2} borderRadius="50%" mr={mr} onClick={() => goToSlide(i)} key={i} />
    );
  });

  return <Flex justify={{ base: "center", md: "left" }}>{dots}</Flex>;
};
